import Image from "next/image";
import { Link, Typography } from "@mui/material";

import { BrowserHooks, ProviderHooks } from "@/src/hook";
import type { StrapiCollectionType } from "@/src/type";
import { LoadFromCDN } from "@/src/util";

import styles from "./TitleLink.module.scss";

interface TitleLinkProps {
  nav: StrapiCollectionType.Navigation;
  isBottom?: boolean;
}

function TitleLink({ nav, isBottom }: TitleLinkProps) {
  const cms = ProviderHooks.useCMS();
  const externalLink = BrowserHooks.useLinkWithTrackingParams(nav?.titleLink?.href ?? "", true);

  return (
    <Link
      href={nav?.titleLink?.isExternal ? externalLink : cms.constructLink(nav?.titleLink?.href ?? "")}
      className={styles.titleLink}
      target={nav?.titleLink?.target}
    >
      {typeof nav?.titleLinkIcon?.data?.attributes?.url === "string" && (
        <Image
          src={nav?.titleLinkIcon?.data?.attributes?.url ?? ""}
          loader={LoadFromCDN.loaderForNextJS}
          width={nav?.titleLinkIconWidth ?? 26}
          height={nav?.titleLinkIconHeight ?? 26}
          alt="Logo"
          priority={true}
          className={styles.image}
        />
      )}
      <Typography
        variant="body1"
        lineHeight={isBottom ? "22px" : "24px"}
        fontSize={isBottom ? "22px" : "24px"}
        className={styles.label}
      >
        {nav?.titleLink?.label}
      </Typography>
    </Link>
  );
}

export default TitleLink;
